import c from "../../utils/constants";

class BotManagerController {
  constructor(BotManagerService, FilterService, $scope) {
    "ngInject"

    this.botManagerService = BotManagerService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.botFlowTestStatusOptions = {
      dataSource: [
        { value: 0, text: "Inactive" },
      ],
      dataTextField: "text",
      dataValueField: "value"      
    };

    this.botFlowLiveStatusOptions = {
      dataSource: [
        { value: 0, text: "Inactive" },
        // { value: 1, text: "Test" },
        { value: 2, text: "Live" }
      ],
      dataTextField: "text",
      dataValueField: "value"      
    };
  }  

  getGridOptions() {
    return {
      dataSource: this.botManagerService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceOnErrorCallback.bind(this)),
      sortable: true,
      pageable: false,
      resizable: true,
      height: "90vh",
      toolbar: [{ name: "create", text: "Create New Flow" }],
      noRecords: {
        template: "No Flows."
      },
      columns: [
        { field: "title", title: "Title", filterable: false, sortable: false, width: "8rem" },
        { field: "flowType", title: "Flow Type", filterable: false, sortable: false, width: "4rem" },
        { field: "flowStatus", title: "Flow Status", filterable: false, sortable: false, width: "4rem", template: (dataItem) => `${this._getFlowStatusText(dataItem.flowStatus)}` },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Update Bot Flow" },
        template: kendo.template($("#bot-manager-popup-editor").html())
      }
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.botManagerMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceOnErrorCallback(response) {
    alert(JSON.parse(response.xhr.responseText).message);
  }

  _getFlowStatusText(type) {
    switch(type) {
      case c.botFlowStatus.INACTIVE: 
        return "Inactive";
      case c.botFlowStatus.TEST:
        return "Test";
      case c.botFlowStatus.LIVE:
        return "Live";
    }
  }  

}

export default BotManagerController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-manager/bot-manager.controller.js
 **/